import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/dashboard/store/appStore';
import { UserRole, UserRoleType } from '@/dashboard/types/user_role';
import { OwnerAdminCreator, OwnerAdminRoles } from '@/dashboard/constants/roles';
import { useAlertStore } from '@/dashboard/store/alertStore';
import { WorkspaceApi } from '@/dashboard/api/workspace';

export function useUserUsageInfoItem(id: number, role?: UserRoleType) {
  const appStore = useAppStore();
  const alertStore = useAlertStore();
  const router = useRouter();

  const { workspace, currentWorkspaceUser, baseWorkspaceShortLink } = storeToRefs(appStore);
  const canShowEmail = computed(() => {
    if (currentWorkspaceUser.value) {
      return OwnerAdminCreator.includes(currentWorkspaceUser.value.role);
    } else {
      return false;
    }
  });
  const canShowMenu = computed(() => {
    if (role && role === UserRole.Owner) return false;
    else if (currentWorkspaceUser.value) {
      return OwnerAdminRoles.includes(currentWorkspaceUser.value.role);
    } else return false;
  });
  const keepPersonalData = ref(true);

  const menu = computed(() => {
    return [
      {
        action: () => {},
        icon: 'CloseCircleIcon',
        label: 'Delete user',
        labelClass: 'text-black dark:text-white',
        iconClass: 'stroke-black dark:stroke-white',
        submenu: [
          // {
          //   action: () => openConfirmAlert(true),
          //   icon: 'FolderIcon',
          //   label: 'Keep Personal dir.',
          //   labelClass: 'text-black dark:text-white',
          //   iconClass: 'stroke-black dark:stroke-white',
          // },
          {
            action: () => openConfirmAlert(false),
            icon: 'CloseCircleIcon',
            label: 'Delete completely',
            labelClass: 'text-hard-error',
            iconClass: 'stroke-hard-error',
          },
        ],
      },
    ];
  });

  async function leaveWorkspace() {
    if (workspace.value && currentWorkspaceUser.value) {
      const data = await WorkspaceApi.deleteUser({
        keepPersonalData: keepPersonalData.value,
        userId: id,
        workspaceShortLink: workspace.value.short_link,
      });

      if (data.success) {
        await appStore.loadWorkspaces();
        const findWorkspace = appStore.workspaces.find((item) => item.id === data.workspace?.id);
        if (findWorkspace && data.workspace?.id === findWorkspace.id) {
          appStore.setWorkspace(data.workspace);
        } else {
          await router.push({
            name: 'workspace',
            params: {
              short_link: baseWorkspaceShortLink.value,
            },
          });
        }
      }
    }
  }

  function openConfirmAlert(keepData: boolean) {
    keepPersonalData.value = keepData;
    const isCurrentUser = id === currentWorkspaceUser.value?.id;
    console.log('is current', isCurrentUser);
    alertStore.open({
      title: 'Are you sure?',
      subtitle: isCurrentUser
        ? `If you leave the workspace, your personal directory (in the workspace: ${workspace.value?.name}) will be permanently deleted.`
        : `If you remove a user from the workspace, their personal directory (in the workspace: ${workspace.value?.name}) will be permanently deleted.`,
      action: leaveWorkspace,
      cancelAction: () => {},
    });
  }

  return {
    menu,
    canShowEmail,
    canShowMenu,
  };
}
